"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}


//////////////////
// WEBPACK FOOTER
// ./~/@weareroam/cake-ui-v1/styles/createStyles.js
// module id = 311
// module chunks = 168707334958949